export default "__VITE_ASSET__zdfGKdEO__"